module.exports = __webpack_public_path__ + "static/media/banner.35bc9bd1.png";